import { IApplicant } from "./applicant/IApplicant";
import { Company } from "./company/Company";
import { IUser, User } from "./User";
import { IActivityStreams, IDocument, ILoan, IProductType } from "../resources/interfaces";
import { Customer } from "./customer/Customer";
import { number } from "prop-types";

export default class Loan {
    id: string | undefined;
    applicationNumber: string | undefined;
    productType: IProductType;
    customer: Customer;
    amount: number;
    approved: boolean;
    approvedOn?: string;
    paid: boolean;
    paidOn?: string;
    requester?: Company;
    reference: string;
    financer?: Company;
    frequency: string;
    period: number;
    tobePaidTo?: Company;
    disbursement: number;
    createdOn: string;
    updatedOn: string;
    repaymentId?: string;
    disbursementReference?: string;
    repaymentAmount?: number;
    disbursed?: boolean;
    monthlyPaymentAmount?: number;
    documents?: IDocument[] | undefined;
    disbursedOn?: string;
    principal?: number;
    interest?: string;
    total?: number;
    dueDate?: string;
    notes?: string;
    firstApprovalBy: string;
    firstApprovalOn: string;
    secondApprovalBy: string;
    secondApprovalOn: string;
    activityStreams?:IActivityStreams[];

    constructor(data: ILoan) {
        this.id = data.id;
        this.applicationNumber = data.applicationNumber;
        this.productType = data.productType;
        this.customer = data.customer;
        this.amount = data.amount;
        this.approved = data.approved;
        this.approvedOn = data.approvedOn;
        this.paid = data.paid;
        this.paidOn = data.paidOn;
        this.requester = data.requester ? new Company(data.requester) : undefined;
        this.reference = data.reference;
        this.financer = data.financer ? new Company(data.financer) : undefined;
        this.frequency = data.frequency;
        this.period = data.period;
        this.tobePaidTo = data.tobePaidTo ? new Company(data.tobePaidTo) : undefined;
        this.disbursement = data.disbursement;
        this.createdOn = data.createdOn;
        this.updatedOn = data.updatedOn;
        this.period = data.period;
        this.repaymentId = data.repaymentId;
        this.disbursementReference = data.disbursementReference;
        this.repaymentAmount = data.repaymentAmount;
        this.disbursed = data.disbursed;
        this.monthlyPaymentAmount = data.monthlyPaymentAmount;
        this.disbursedOn = data.disbursedOn;
        this.principal = data.principal;
        this.interest = data.interest;
        this.total = data.total;
        this.dueDate = data.dueDate;
        this.notes = data.notes;
        this.activityStreams = data.activityStreams;
        this.firstApprovalBy = data.firstApprovalBy;
        this.firstApprovalOn = data.firstApprovalOn;
        this.secondApprovalBy = data.secondApprovalBy;
        this.secondApprovalOn = data.secondApprovalOn;
    }
}